import { DnsApiClient } from '@fourthwall/services/dist/DnsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useGetEntriAuthTokenMutation = createMutationHook(DnsApiClient.getEntriAuthToken, {
  mutationKey: ['entriAuthToken'],
})
